/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Views_No_MatchInputs */

const en_views_no_match = /** @type {(inputs: Views_No_MatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No view matches ${i?.query}.`)
};

const de_views_no_match = /** @type {(inputs: Views_No_MatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keine Ansicht passt zu ${i?.query}.`)
};

/**
* | output |
* | --- |
* | "No view matches {query}." |
*
* @param {Views_No_MatchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_no_match = /** @type {((inputs: Views_No_MatchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_No_MatchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_no_match(inputs)
	return en_views_no_match(inputs)
});